<template>
	<section>
		<header-page
			actions
			name="accounting-analysis"
			:title="$route.meta.title"
		/>
		<app-actions
				:resource-uri="$route.name"
		/>
		<div class="pt-3 px-4">
			<v-layout row align-center wrap>
				<v-flex xs4 md2 pr-2 lg2>
					<BaseSelect
						class="select-accouting"
						label="Análisis Contable"
						item-text="name"
						item-value="id"
						:height="32"
						v-model="typeAnalysis"
						:items="itemsAccountingAnalysis"
						:value="typeAnalysis"
						@input="setTypeAnalysis"
					/>
				</v-flex>
				<v-flex xs4 md2 pr-2 lg2 v-if="typeAnalysis === 2">
					<BaseSelect
						class="select-accouting"
						label="Módulos"
						item-text="name"
						item-value="code"
						:height="32"
						v-model="moduleId"
						:items="modules"
						:value="moduleId"
						@input="setModule"
					/>
				</v-flex>
				<!-- <v-flex xs4 md2 pr-2 lg2>
					<BaseSelect
						class="select-accouting"
						label="Cuenta Contable"
						item-text="fullName"
						item-value="account"
						:height="32"
						v-model="accountId"
						:items="accounts"
						:value="accountId"
						@input="setAccountingAccount"
					/>
				</v-flex> -->
				<v-flex xs4 md2 pr-2 lg2 v-if="typeAnalysis === 2">
					<BaseSelect
						class="select-accouting"
						label="Datos"
						item-text="name"
						item-value="id"
						:height="32"
						v-model="params.filterBalance"
						:items="balanceData"
						:value="params.filterBalance"
						@input="setTypeBalance"
					/>
				</v-flex>
				<v-flex xs4 md2 pr-2 lg2>
					<BaseSelect
						class="select-accouting"
						item-text="name"
						item-value="id"
						label="Fechas"
						:height="32"
						:items="typesDate"
						v-model="typeDateId"
						@input="getDataDate($event)"
					/>
				</v-flex>
				<v-flex xs3 md1 pr-2 lg2 v-if="flagDate && typeAnalysis === 2">
					<span class="captionDate">Fecha Desde</span>
					<date-component
						round
						:date="params.startDate"
						icon="/static/img/calendar.svg"
						@on-input="getDate({ model: 'startDate', value: $event })"
					></date-component>
				</v-flex>
				<v-flex xs3 md1 pr-2 lg2 v-if="flagDate">
					<span class="captionDate">Fecha Hasta</span>
					<date-component
						round
						:date="params.endDate"
						icon="/static/img/calendar.svg"
						@on-input="getDate({ model: 'endDate', value: $event })"
					></date-component>
				</v-flex>
				<v-flex xs2 md1>
					<v-btn
						:disabled="getValidaDisabled()"
						color="blue"
						class="ma-0 btn-accounting mt-3 desktop"
						@click="loadData(false)"
					>
						Buscar
					</v-btn>
				</v-flex>
				<v-flex xs1 md1 pt-3 v-if="typeAnalysis === 2">
					<app-button-list
						:img="'/static/img/icons/excel2.svg'"
						:options="options"
						show-report-menu
						:open-on-click="isModuleSelected"
						@click-menu="clickMenu"
						@emit-report="downloadReport">
					</app-button-list>
					<!-- <app-tooltip-button
						class="no-movil"
						color="success"
						:img="'/static/img/icons/excel2.svg'"
						text="Descargar Cubo Excel"
						:width="30"
						:disabled="!moduleId"
						@click-icon="donwloadExcel"
					/> -->
				</v-flex>
				<!-- <v-flex xs1 md1 pt-3>
					<app-tooltip-button
						class="no-movil"
						color="success"
						:img="'/static/img/icons/excel2.svg'"
						text="Descargar Pivot Excel"
						:width="30"
						:disabled="!moduleId"
						@click-icon="donwloadExcelPivot"
					/>
				</v-flex> -->
			</v-layout>
		</div>
		<div class="pivot-container px-4 pt-3" v-if="typeAnalysis === 2">
			<vue-pivottable-ui
				:data="tableData"
				:rows="rows"
				:cols="cols"
				:locale-strings="localeStrings"
				:aggregator-name="'Sum'"
				:vals="vals"
				>
			</vue-pivottable-ui>
		</div>
		<div class="pivot-container px-4 pt-3" v-if="typeAnalysis === 1">
			<div
				ref="viewer"
				id="result"
				class="hidden-sm-and-down"
			></div>
		</div>
		
	</section>
</template>

<script>
import appActions from '@/components/shared/app-actions/app-actions';
import BaseSelect from '@/components/shared/inputs/base-select';
import dateComponent from '@/components/autocomplete/date-component';
import appTooltipButton from '@/components/shared/app-tooltip-button';
import { endOfMonth, format, subDays } from 'date-fns';
import { VuePivottableUi } from 'vue-pivottable';
import { mapGetters } from 'vuex';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import helper from '@/shared/helper';

function created() {
	this.loadAccounts();
	this.loadModules();
	this.params.startDate = format(subDays(this.$today, 7), 'YYYY-MM-DD');
	this.params.endDate = this.$today;
	this.params.filterBalance = 1;
	this.typeAnalysis = 1;
	this.getDataDate(6);
}

async function loadAccounts() {
	this.subsidiaryIdSelected = this.subsidiaryId || this.currentSubsidiary.id;
	const params = {
		status: 1,
	};
	({ data: this.accounts } = await this.$http.get(
		`accounting-plan/${this.subsidiaryIdSelected}/subsidiary`, { params }));
	if (this.showSeatForm) {
		this.accounts = this.accounts.filter(a => a.auxCont === 0);
	}
}

async function loadModules() {
	const params = {
		subsidiaryId: this.subsidiaryId || this.currentSubsidiary.id,
	};
	({ data: this.modules } = await this.$http.get('type-register', { params }));
	this.modules = this.modules.filter(m => m.code === 'VENTA' || m.code === 'COMPRA' || m.code === 'CTAXPAG' || m.code === 'CTAXCOB' || m.code === 'BANCO' || m.code === 'CAJA');
	if (this.modules.length === 1) {
		this.moduleId = this.modules[0].code;
	}
}

function getDataDate(val) {
	this.typeDateId = val;
	if (val === 1) {
		this.params.startDate = this.$today;
		this.params.endDate = this.$today;
		this.flagDate = false;
	} else if (val === 2) {
		this.params.startDate = format(subDays(this.$today, 1), 'YYYY-MM-DD');
		this.params.endDate = format(subDays(this.$today, 1), 'YYYY-MM-DD');
		this.flagDate = false;
	} else if (val === 3) {
		this.params.startDate = format(subDays(this.$today, 7), 'YYYY-MM-DD');
		this.params.endDate = this.$today;
		this.flagDate = false;
	} else if (val === 4) {
		const today = new Date(this.$today);
		const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
		this.params.startDate = firstDayOfMonth.toISOString().split('T')[0];
		this.params.endDate = this.$today;
		this.flagDate = false;
	} else if (val === 5) {
		const today = new Date(this.$today);
		// Set the startDate to the first day of the current year
		const firstDayOfYear = new Date(today.getFullYear(), 0, 1);
		this.params.startDate = firstDayOfYear.toISOString().split('T')[0];
		this.params.endDate = this.$today;
		this.flagDate = false;
	} else if (val === 6) {
		this.params.startDate = format(subDays(this.$today, 7), 'YYYY-MM-DD');
		this.params.endDate = this.$today;
		this.flagDate = true;
	}
}

function getDate({ value, model }) {
	if (model === 'startDate') {
		this.params[model] = format(value, 'YYYY-MM-DD');
		this.params.endDate = format(endOfMonth(value), 'YYYY-MM-DD');
	} else if (model === 'endDate') {
		this.params[model] = format(value, 'YYYY-MM-DD');
	}
}

function setAccountingAccount(value) {
	this.codeAccounting = value;
}

function setTypeBalance(value) {
	this.params.filterBalance = value;
}

async function loadData(excel) {
	const params = {
		...this.params,
		flagExcel: this.flagExcel,
	};
	const body = {
		moduleCode: this.moduleId,
		subsidiaryId: this.currentSubsidiary.id,
	};
	delete params.limit;
	delete params.page;
	try {
		if (this.typeAnalysis === 2) {
			if (excel) {
				let url = '';
				if (this.moduleId === 'VENTA') {
					url = 'processing-storage';
				} else if (this.moduleId === 'CTAXPAG') {
					url = 'processing-storage-cxp';
				} else if (this.moduleId === 'CTAXCOB') {
					url = 'processing-storage-cxc';
				} else if (this.moduleId === 'BANCO') {
					url = 'processing-storage-banks';
				} else if (this.moduleId === 'CAJA') {
					url = 'processing-storage-cash';
				}
				const { data: response } = await this.$http.post(url, body, { params });
				const mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
				const blob = this.base64ToBlob(response.base64, mimeType);
				const nameFile = `Reporte-${this.moduleId}-${this.params.startDate}-${this.params.endDate}`;
				saveAs(blob, `${nameFile}.xlsx`);
			} else {
				delete params.flagExcel;
				let url = '';
				if (this.moduleId === 'VENTA') {
					url = 'processing-storage';
				} else if (this.moduleId === 'CTAXPAG') {
					url = 'processing-storage-cxp';
				} else if (this.moduleId === 'CTAXCOB') {
					url = 'processing-storage-cxc';
				} else if (this.moduleId === 'BANCO') {
					url = 'processing-storage-banks';
				} else if (this.moduleId === 'CAJA') {
					url = 'processing-storage-cash';
				}
				const { data: response } = await this.$http.post(url, body, { params });
				this.tableData = response;
			}
		} else if (this.typeAnalysis === 1) {
			delete params.flagExcel;
			delete params.filterBalance;
			delete params.startDate;
			const newParams = {
				responseType: 'blob',
				params: { ...params },
			};
			const newBody = {
				subsidiaryId: this.currentSubsidiary.id,
				code: 'accounting-total-aux-mayor',
			};
			const { data: blobData } = await this.$http.post('processing-storage-acc-aux-mayor', newBody, newParams);
			const blob = helper.generateBlob(blobData);
			const urlObject = URL.createObjectURL(blob);
			const iFrame = document.createElement('iframe');
			iFrame.setAttribute('src', urlObject);
			iFrame.setAttribute('style', 'height:100vh;width:100%');
			const childNodes = this.$refs.viewer.childNodes;
			if (childNodes.length > 0) {
				this.$refs.viewer.removeChild(this.$refs.viewer.childNodes[0]);
			}
			this.$refs.viewer.append(iFrame);
		}
	} catch (error) {
		this.showGenericError();
	} finally {
		this.flagExcel = false;
	}
}

function base64ToBlob(base64, mime) {
	const byteCharacters = atob(base64);
	const byteNumbers = new Array(byteCharacters.length);
	for (let i = 0; i < byteCharacters.length; i += 1) {
		byteNumbers[i] = byteCharacters.charCodeAt(i);
	}
	const byteArray = new Uint8Array(byteNumbers);
	return new Blob([byteArray], { type: mime });
}

function donwloadExcel() {
	this.flagExcel = true;
	this.loadData(true);
}

function donwloadExcelPivot() {
	const resultTable = document.querySelector('.pvtTable');
	if (resultTable) {
		const ws = XLSX.utils.table_to_sheet(resultTable);
		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, 'Pivot Results');
		const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
		const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
		const nameFile = `${this.moduleId}-${this.params.startDate}-${this.params.endDate}`;
		saveAs(blob, `pivot-table-result-${nameFile}.xlsx`);
	} else {
		this.showGenericError('No se encontró la tabla de resultados.');
	}
}

function setTypeAnalysis(value) {
	this.typeAnalysis = value;
	if (value === 1) {
		this.moduleId = null;
		this.params.filterBalance = null;
		this.getDataDate(6);
	} else {
		this.tableData = [];
		this.params.filterBalance = 1;
		this.getDataDate(4);
	}
}

function setModule(value) {
	this.moduleId = value;
}

function clickMenu() {
	if (!this.moduleId) {
		this.showNotification('Debe seleccionar un módulo', 'warning');
	}
}

function isModuleSelected() {
	return Boolean(this.moduleId);
}

function downloadReport(code) {
	if (code === 'report') {
		this.donwloadExcel();
	} else if (code === 'pivot-report') {
		this.donwloadExcelPivot();
	}
}

function getValidaDisabled() {
	let value = false;
	if (this.typeAnalysis === 2) {
		value = !this.moduleId;
	}
	return value;
}

function data() {
	return {
		accounts: [],
		typesDate: [
			{ id: 1, name: 'Hoy' },
			{ id: 2, name: 'Ayer' },
			{ id: 3, name: 'Ultima Semana' },
			{ id: 4, name: 'Mes Actual' },
			{ id: 5, name: 'Año Actual' },
			{ id: 6, name: 'Rangos de Fechas' },
		],
		flagDate: false,
		params: {
			startDate: null,
			endDate: null,
			filterBalance: null,
		},
		codeAccounting: null,
		subsidiaryIdSelected: null,
		accountId: null,
		tableData: [],
		col: [],
		rows: ['DIARIO'],
		cols: ['ORIGEN', 'CUENTA'],
		localeStrings: {
			renderError: 'Ocurrió un error al mostrar la tabla dinámica.',
			computeError: 'Ocurrió un error al calcular la tabla dinámica.',
			selectAll: 'Seleccionar todo',
			selectNone: 'Deseleccionar todo',
		},
		balanceData: [
			{ id: 1, name: 'General' },
			{ id: 2, name: 'Cuadrados' },
			{ id: 3, name: 'No Cuadrados' },
		],
		flagExcel: false,
		modules: [],
		moduleId: null,
		vals: ['IMPORTE'],
		options: [
			{ id: 1, code: 'report', name: 'Descargar Excel' },
			{ id: 2, code: 'pivot-report', name: 'Descargar Pivot Excel' },
		],
		itemsAccountingAnalysis: [
			{ id: 1, name: 'Diferencia de Auxiliares vs Mayores', code: 'difference-between-assistants-majors' },
			{ id: 2, name: 'Análisis por Módulos', code: 'analysis-by-modules' },
		],
		typeAnalysis: null,
		typeDateId: null,
	};
}

export default {
	name: 'page-accounting-analysis',
	created,
	data,
	components: {
		appActions,
		BaseSelect,
		appTooltipButton,
		dateComponent,
		VuePivottableUi,
	},
	methods: {
		loadAccounts,
		loadModules,
		getDataDate,
		getDate,
		setAccountingAccount,
		setTypeBalance,
		loadData,
		donwloadExcel,
		donwloadExcelPivot,
		base64ToBlob,
		setTypeAnalysis,
		setModule,
		clickMenu,
		downloadReport,
		getValidaDisabled,
	},
	computed: {
		...mapGetters('subsidiary', [
			'currentSubsidiary',
		]),
		isModuleSelected,
	},
};
</script>

<style lang="scss" scoped>
.captionDate {
	font-size: 10px;
	text-align: center;
	font-family: 'AvenirRegular';
}
.btn-accounting {
	border-radius: 24px !important;
	box-shadow: none !important;
	color: white !important;
	font-family: map-get($fonts, AvenirRegular) !important;
	font-size: 12px !important;
	font-weight: 600;
	text-transform: capitalize !important;
	width: 80px;

	@media (max-width: 1024px) {
		width: 100%;
	}
}

// .pvtUi {
//   display: flex;
// }

// .pvtUi .pvtAxisContainer {
//   font-size: 12px;
// }

// .pvtUi select, .pvtUi input {
//   font-size: 12px;
// }

.pivot-container {
  max-width: 100%;  /* El ancho máximo del contenedor no supera el 100% */
  overflow-x: auto; /* Habilitar el scroll horizontal */
}


.pvtUi {
  display: grid;
  grid-template-columns: 400px auto; /* Ajusta el tamaño de la columna izquierda */
}

.pvtUi .pvtAxisContainer, 
.pvtUi .pvtVals,
.pvtUi .pvtRenderer {
  font-size: 12px; /* Ajusta el tamaño del texto en las opciones de filas, columnas, y el selector de tablas */
}

/* Reducir el tamaño de los selectores e inputs */
.pvtUi select, .pvtUi input {
  font-size: 12px;
  padding: 2px;
}

/* Ajustar los contenedores de arrastrar y soltar filas/columnas */
.pvtAxisContainer {
  max-height: 100px; /* Controla el alto del contenedor de filas/columnas */
  overflow-y: auto;
}
.pvtTable {
  max-width: 100%; /* Limitar el ancho máximo de la tabla */
  width: auto;     /* La tabla se ajusta a su contenido */
}
</style>


// WEBPACK FOOTER //
// src/pages/accounting-analysis/page-accounting-analysis.vue